/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreatePayrollGroupRequest } from '../models/CreatePayrollGroupRequest';
import type { Page_PayrollGroupResponse_ } from '../models/Page_PayrollGroupResponse_';
import type { PayrollGroupDetailProjection } from '../models/PayrollGroupDetailProjection';
import type { PayrollGroupProjection } from '../models/PayrollGroupProjection';
import type { PayrollGroupResponse } from '../models/PayrollGroupResponse';
import type { PayrollGroupStaffResponse } from '../models/PayrollGroupStaffResponse';
import type { UpdatePayrollGroupRequest } from '../models/UpdatePayrollGroupRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class PayrollGroupControllerService {
  /**
   * getAllPayrollGroups
   * @returns Page_PayrollGroupResponse_ OK
   * @throws ApiError
   */
  public static getAllPayrollGroupsUsingGet({
    limit = 10,
    offset,
    search,
  }: {
    /**
     * limit
     */
    limit?: number;
    /**
     * offset
     */
    offset?: number;
    /**
     * search
     */
    search?: string;
  }): CancelablePromise<Page_PayrollGroupResponse_> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/payroll/groups',
      query: {
        limit: limit,
        offset: offset,
        search: search,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * createPayrollGroup
   * @returns PayrollGroupResponse OK
   * @returns any Created
   * @throws ApiError
   */
  public static createPayrollGroupUsingPost({
    request,
  }: {
    /**
     * request
     */
    request: CreatePayrollGroupRequest;
  }): CancelablePromise<PayrollGroupResponse | any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/payroll/groups',
      body: request,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * getAllPayrollGroupProjections
   * @returns PayrollGroupProjection OK
   * @throws ApiError
   */
  public static getAllPayrollGroupProjectionsUsingGet(): CancelablePromise<
    Array<PayrollGroupProjection>
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/payroll/groups/projections',
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * getPayrollGroup
   * @returns PayrollGroupResponse OK
   * @throws ApiError
   */
  public static getPayrollGroupUsingGet({
    id,
  }: {
    /**
     * id
     */
    id: string;
  }): CancelablePromise<PayrollGroupResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/payroll/groups/{id}',
      path: {
        id: id,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * updatePayrollGroup
   * @returns PayrollGroupResponse OK
   * @returns any Created
   * @throws ApiError
   */
  public static updatePayrollGroupUsingPut({
    id,
    request,
  }: {
    /**
     * id
     */
    id: string;
    /**
     * request
     */
    request: UpdatePayrollGroupRequest;
  }): CancelablePromise<PayrollGroupResponse | any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/payroll/groups/{id}',
      path: {
        id: id,
      },
      body: request,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * deletePayrollGroup
   * @returns any OK
   * @throws ApiError
   */
  public static deletePayrollGroupUsingDelete({
    id,
  }: {
    /**
     * id
     */
    id: string;
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/payroll/groups/{id}',
      path: {
        id: id,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
      },
    });
  }

  /**
   * getPayrollGroupDetails
   * @returns PayrollGroupDetailProjection OK
   * @throws ApiError
   */
  public static getPayrollGroupDetailsUsingGet({
    id,
  }: {
    /**
     * id
     */
    id: string;
  }): CancelablePromise<PayrollGroupDetailProjection> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/payroll/groups/{id}/details',
      path: {
        id: id,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * getPayrollGroupStaff
   * @returns PayrollGroupStaffResponse OK
   * @throws ApiError
   */
  public static getPayrollGroupStaffUsingGet({
    id,
  }: {
    /**
     * id
     */
    id: string;
  }): CancelablePromise<Array<PayrollGroupStaffResponse>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/payroll/groups/{id}/staff',
      path: {
        id: id,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * assignStaffToGroup
   * @returns any OK
   * @throws ApiError
   */
  public static assignStaffToGroupUsingPost({
    id,
    staffId,
  }: {
    /**
     * id
     */
    id: string;
    /**
     * staffId
     */
    staffId: string;
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/payroll/groups/{id}/staff',
      path: {
        id: id,
      },
      query: {
        staffId: staffId,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * removeStaffFromGroup
   * @returns any OK
   * @throws ApiError
   */
  public static removeStaffFromGroupUsingDelete({
    id,
    staffId,
  }: {
    /**
     * id
     */
    id: string;
    /**
     * staffId
     */
    staffId: string;
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/payroll/groups/{id}/staff/{staffId}',
      path: {
        id: id,
        staffId: staffId,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
      },
    });
  }
}
